export {
  IIconRecord,
  IIconSubset,
  IIconSubsetRecord,
  IIconOptions,
  getIcon,
  registerIcons,
  registerIconAlias,
  unregisterIcons,
  setIconOptions,
} from './utilities/icons';

export { getIconClassName } from './utilities/getIconClassName';
